const REFRESH_TOKEN_KEY = 'refresh_token'
const ACCESS_TOKEN_KEY = 'access_token'

// TODO: to be implemented later on
// let accessToken = null

export const tokenStore = {
  getAccessToken () {
    // return accessToken
    return sessionStorage.getItem(ACCESS_TOKEN_KEY)
  },
  getRefreshToken () {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY)
  },
  setTokens (newAccessToken, newRefreshToken) {
    // accessToken = newAccessToken
    sessionStorage.setItem(ACCESS_TOKEN_KEY, newAccessToken)
    if (newRefreshToken)
      sessionStorage.setItem(REFRESH_TOKEN_KEY, newRefreshToken)
  },
  clearTokens () {
    // accessToken = null
    sessionStorage.removeItem(ACCESS_TOKEN_KEY)
    sessionStorage.removeItem(REFRESH_TOKEN_KEY)
  }
}
